<template>
    <div class="md-listing-list broker" v-if="showThisModule">
        <div class="f-col" :style="spaceStyle">
            <listing-content :recentListingTitle="cmpRecentListingTitle" :presetFilters="normalizedFilter"/>
        </div>
    </div>
</template>

<script>
import spaceMixin from '@/modules/space-mixin';
import common from '../index';
import Content from './components/content';
// import RecentListings from './components/recent-listings'
export default {
    mixins: [common, spaceMixin()],
    components: {
        'listing-content': Content
        //   'recent-listings': RecentListings,
    }
};
</script>
